var $b0279559630533ac$exports = {};
$b0279559630533ac$exports = {
    "replaceMessage": `D\xe9poser le fichier \xe0 remplacer`
};


export {$b0279559630533ac$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
